import {Bar, toggleNav} from '../js/main'
import './form-submission-handler'
import '../css/reset.css'
import '../css/constants.css'
import '../css/main.css'
import './contact.css'
toggleNav()

// https://stackoverflow.com/a/34992098/12268569
let submitButton = document.querySelector('[type="submit"]')
submitButton.addEventListener('click', function () {
    // this adds 'required' class to all the required inputs under the same <form> as the submit button
    const requiredNodeList = submitButton.closest('form').querySelectorAll('[required]')
    requiredNodeList.forEach(e => e.classList.add('required'))
});

console.log('This is contact js')